<template>
	<div class="message-tip">
		<Message v-if="messageType == 'showInstallNasPlugin'">
			<template v-slot:content>
				<div class="install-plugin-tip">
					<div class="close-btn" @click="closeClick"></div>
					<div class="title">请安装NAS插件</div>
					<div class="message-box" v-if="installNasFlag">
						<div class="message-text1">
							请先确认您的设备属于哪个架构平台，然后选择现在对应的插件进行安装
						</div>
						<div class="plugs">
							<div class="plug1-icon" @click="installQhNasClick">
								群晖
							</div>
							<div class="plug2-icon" @click="installHkNasClick">
								联想 | 海康
							</div>
							<div class="plug2-tip" v-if="installNasHkFlag">
								<div class="plug2-tip-text">
									请在<span>设备应用中心</span>下载安装插件
								</div>
							</div>
						</div>
					</div>
					<div class="qh-plug-box" v-if="installNasQhFlag">
						<div class="qh-plug-text">点击对应的平台下载插件</div>
						<div class="qh-plugs-wrap">
							<div class="qh-plug-text1">群晖</div>
							<div class="qh-plugs">
								<div>DSM6_x86</div>
								<div>DSM7_x86</div>
								<div>DSM6_arm</div>
								<div>DSM7_arm</div>
							</div>
						</div>
					</div>
					<div
						class="install-nas-refresh-wrap"
						@click="refreshInstallNasClick"
					>
						<div class="install-plugin-refresh">
							提示：安装NAS插件并绑定后请刷新本页面
						</div>
						<img src="../assets/home/node/plug_refresh.png" />
					</div>
				</div>
			</template>
		</Message>
		<Message
			v-if="messageType == 'showDownloadWindowsApp'"
			my-height="308px"
			my-width="412px"
		>
			<template v-slot:content>
				<div class="download-win-v2">
					<div class="download-close" @click="closeClick"></div>
					<div class="tip" v-if="tip">{{ tip }}</div>
					<div class="download-title">远程桌面</div>
					<div class="download-title2">请使用客户端访问远程桌面</div>
					<div class="download-item-wrap">
						<div class="item-left"></div>
						<div class="item-right">
							<div class="right1" @click="goDownloadUrl">
								<div class="right-icon"></div>
								访问
							</div>
							<div class="right2" @click="goDownloadPage">
								<div class="right-icon"></div>
								下载
							</div>
						</div>
					</div>
					<div class="download-item2">客户端下载地址</div>
					<div
						class="copy-class"
						data-clipboard-text="https://www.iepose.com/download?client=home"
						@click="copyClick"
					>
						https://www.iepose.com/download?client=home
					</div>
				</div>
			</template>
		</Message>
		<Message v-if="messageType == 'showDownloadMacMstscApp'">
			<template v-slot:content>
				<div class="install-client-tip">
					<div class="close-btn" @click="closeClick"></div>
					<img src="../assets/home/node/client_icon.png" />
					<div class="install-client-text">
						<div class="install-client-text1">
							请安装<br />
							Microsoft Remote Desktop
						</div>
						<div class="install-client-text2">
							安装后您可使用Mac访问windows远程桌面
						</div>
						<div
							class="install-client-text3"
							@click="downloadMacMstscHelpClick"
						>
							安装/使用教程>
						</div>
					</div>
					<div class="line"></div>
					<div
						class="install-mac-mstsc-btn"
						@click="downloadMacMstscClick"
					>
						<div
							class="install-client-btn-text"
							title="节点小宝客户端下载"
						>
							Microsoft Remote Desktop 下载
						</div>
						<div class="install-client-icon"></div>
					</div>
				</div>
			</template>
		</Message>
		<Message v-if="messageType == 'showDownloadWindowsAppTypeCustom'">
			<template v-slot:content>
				<div class="install-client-tip">
					<div class="close-btn" @click="closeClick"></div>
					<img src="../assets/home/node/client_icon.png" />
					<div class="install-client-text">
						<div class="install-client-text1">
							节点小宝Windows端应用
						</div>
						<div class="install-client-icons">
							<div
								class="install-client-icon install-client-icon-01"
							></div>
							<div
								class="install-client-icon install-client-icon-02"
							></div>
						</div>
						<div class="install-client-text2">
							网页版暂不支持自定义端口映射<br />请下载节点小宝Windows客户端应用
						</div>
					</div>
					<div class="line"></div>
					<div class="install-client-btn" @click="downloadClick">
						<div
							class="install-client-btn-text"
							title="节点小宝客户端下载"
						>
							节点小宝客户端下载
						</div>
						<div class="install-client-icon"></div>
					</div>
				</div>
			</template>
		</Message>
		<Message v-if="messageType == 'showRemoteWakeup'">
			<template v-slot:content>
				<div class="help-tip">
					<div class="skip">
						<div class="skip-text" @click="ignoreRemoteWakeupTips">
							跳过
						</div>
					</div>
					<div class="help-title">远程开机指引</div>
					<div class="help-text-wrap" v-if="remoteWakeupStep == 1">
						<img src="../assets/home/node/help.png" />
						<div class="help-tip-text">
							<div class="help-tip-text1">
								确认电脑是否支持网络唤醒
							</div>
							<div class="help-tip-text2">
								重启电脑设备进入BIOS的电源管理菜单查看菜单是否有Remote
								Wake Up或Wake on
								LAN等类似选项，否则不支持远程开机。
							</div>
						</div>
					</div>
					<div
						class="help-text-wrap1"
						v-else-if="remoteWakeupStep == 2"
					>
						<div class="help-text1">主机BIOS设置</div>
						<div class="help-text2">
							进入BIOS开启电源管理配置，主板厂商定义不一，以下供参考：
						</div>
						<div class="help-text3">
							<div class="help-text3-box">
								<div>"Boot on LAN";</div>
								<div>"PME Event WakeUp";</div>
								<div>"PME Event WakeUp";</div>
							</div>
							<div class="bios-setting-line"></div>
							<div class="help-text3-box">
								<div>"Resume by MAC LAN";</div>
								<div>"Wake-Up by PCI card";</div>
								<div>"Wake Up On PCI PME";</div>
								<div>"Power On by PCI Card";</div>
							</div>
							<div class="bios-setting-line"></div>
							<div class="help-text3-box">
								<div>"WakeUp by PME of PCI";</div>
								<div>"Power On By PCI Devices";</div>
								<div>"WakeUp by Onborad LAN";</div>
								<div>"Resume By PCI or PCI-E Ddevice"</div>
							</div>
						</div>
						<div class="help-text4">
							若任无法找到相应配置，请查阅 <span>帮助文档</span>
						</div>
					</div>
					<div
						class="help-text-wrap2"
						v-else-if="remoteWakeupStep == 3"
					>
						<div class="start-wrap">
							<div class="start-text1">开机</div>
							<div class="start-text2">
								若已完成上述配置，可点击开机按钮测试开机功能。
							</div>
						</div>
						<img src="../assets/home/node/help_icon.png" />
					</div>
					<div class="help-line"></div>
					<img
						src="../assets/home/node/client_steps.png"
						class="help-steps-icon"
						v-if="remoteWakeupStep <= 1"
					/>
					<img
						src="../assets/home/node/client_steps2.png"
						class="help-steps-icon"
						v-if="remoteWakeupStep == 2"
					/>
					<img
						src="../assets/home/node/help_arrow1.png"
						class="help-steps-icon"
						v-if="remoteWakeupStep >= 3"
					/>
					<div
						:class="{
							'last-step': true,
							active: remoteWakeupStep > 1 ? true : false,
						}"
						@click="onRemoteWakeupPrevClick"
					>
						上一步
					</div>
					<div
						:class="{
							'next-step': true,
							active: remoteWakeupStep < 4 ? true : false,
						}"
						@click="onRemoteWakeupNextClick"
					>
						{{ remoteWakeupStep > 2 ? "开机" : "下一步" }}
					</div>
				</div>
			</template>
		</Message>
		<Message v-if="messageType == 'showRemoteWakeupSuccess'">
			<template v-slot:content>
				<div class="wakeup-success-wrap">
					<img
						src="../assets/home/node/close.png"
						class="close-btn"
						@click="closeClick"
					/>
					<div class="wakeup-success-icon"></div>
					<div class="wakeup-success-title">已下发开机指令</div>
					<div class="wakeup-success-tips">
						若无法开启请查看<span @click="showWakeupTips"
							>开机指引</span
						>
					</div>
					<div class="done-btn" @click="closeClick">确 定</div>
				</div>
			</template>
		</Message>
		<Message
			v-if="messageType == 'showBind'"
			:add_device_class="add_device_class"
		>
			<template v-slot:content>
				<div class="add-device-wrap">
					<img
						src="../assets/home/node/close.png"
						@click="closeClick"
					/>
					<div class="add-device-title">添加设备</div>
					<div class="add-device-line"></div>
					<div class="bind-code-text">请输入设备绑定码</div>
					<input v-model="bindCode" type="number" />
					<div class="add-device-btn">确 定</div>
				</div>
			</template>
		</Message>
		<Message
			v-if="messageType == 'showRemove'"
			:add_device_class="add_device_class"
		>
			<template v-slot:content>
				<div class="remove-device-wrap">
					<img
						src="../assets/home/node/close.png"
						class="remove-device-close"
						@click="closeClick"
					/>
					<div class="remove-device-title">移除服务</div>
					<div class="remove-device-line"></div>
					<div class="remove-device-tip">
						<img src="../assets/home/node/device_remove.png" />
						<div>
							移除该设备后将不在列表显示。可通过搜索设备重新添加该设备。
						</div>
					</div>
					<div class="remove-device-btn" @click="removeServiceClick">
						确定
					</div>
					<div class="disappear-wrap" @click="disappearClick">
						<div
							:class="{
								'disappear-icon': true,
								'disappear-icon-checked': disappear_icon_flag,
							}"
						></div>
						<div class="disappear-text">不再显示该弹窗</div>
					</div>
				</div>
			</template>
		</Message>
		<Message
			v-if="messageType == 'showBindLimit'"
			:add_device_class="add_device_class"
		>
			<template v-slot:content>
				<div class="remove-device-wrap">
					<img
						src="../assets/home/node/close.png"
						class="remove-device-close"
						@click="closeClick"
					/>
					<div class="remove-device-title">提醒</div>
					<div class="remove-device-line"></div>
					<div class="remove-device-tip bind-device-tip">
						<img src="../assets/common/warn_icon.png" />
						<div>
							当前账号绑定设备已达上限，开通小宝VIP增加设备绑定数。
						</div>
					</div>
					<div class="go-pay-btn" @click="goPay">开通会员</div>
				</div>
			</template>
		</Message>
		<Message
			v-if="messageType == 'showUnbind'"
			:add_device_class="add_device_class"
		>
			<template v-slot:content>
				<div class="device-unbind-wrap">
					<img
						src="../assets/home/node/close.png"
						class="device-unbind-close"
						@click="closeClick"
					/>
					<div class="device-unbind-title">解绑设备</div>
					<div class="device-unbind-tip">
						<img src="../assets/home/node/device_unbind.png" />
						<div>
							解绑设备后将无法使用小宝望远镜服务，已开启的小宝驿站服务也将不再享受积分收益。
						</div>
					</div>
					<div class="device-unbind-btn-group">
						<div class="device-unbind-btn1" @click="doUnbindClick">
							解绑设备
						</div>
						<div class="device-unbind-btn2" @click="closeClick">
							继续使用
						</div>
					</div>
				</div>
				<div class="device-unbind-check-wrap" v-if="isShowUnbindCheck">
					<div class="check-title">确认解绑</div>
					<div class="check-tips">是否确认解绑以下设备</div>
					<div class="check-name">【{{ unbindDevName }}】</div>
					<div class="check-btns">
						<div
							class="check-btn check-sure-btn"
							@click="doUnbindCheck"
						>
							确认
						</div>
						<div
							class="check-btn check-cancel-btn"
							@click="hideUnbindCheck"
						>
							继续使用
						</div>
					</div>
				</div>
			</template>
		</Message>
	</div>
</template>

<script>
import Message from "./Message.vue";
import Clipboard from "clipboard";

export default {
	components: {
		Message,
	},
	props: {
		messageType: String,
		unbindDevName: String,
	},
	data: function () {
		return {
			isShowUnbindCheck: false,
			installNasFlag: true, //默认true显示安装nas弹框
			installNasQhFlag: false, //true显示群晖插件弹框
			installNasHkFlag: false, //true显示海康弹框
			add_device_class: true, //控制样式的标识
			bindCode: "",
			disappear_icon_flag: false, //移除服务弹框里面的，true选中，false未选中
			remoteWakeupStep: 1,
			tip: "",
		};
	},
	methods: {
		copyClick: function () {
			let _that = this;
			let clipboard = new Clipboard(".copy-class");
			clipboard.on("success", (e) => {
				clipboard.destroy();
				_that.tip = "复制成功";
				setTimeout(function () {
					_that.tip = "";
				}, 1500);
			});
			clipboard.on("error", (e) => {
				clipboard.destroy();
				_that.tip = "复制失败";

				setTimeout(function () {
					_that.tip = "";
				}, 1500);
			});
		},
		showUnbindCheck: function () {
			let _that = this;
			_that.isShowUnbindCheck = true;
		},
		hideUnbindCheck: function () {
			let _that = this;
			_that.isShowUnbindCheck = false;
			_that.closeClick();
		},
		doUnbindCheck: function () {
			let _that = this;
			_that.hideUnbindCheck();
			_that.$emit("doUnbindClick");
		},
		downloadClick: function () {
			let _that = this;
			let url = _that.$store.state.app_url.windows;
			_that.$common.bridge(_that.$store.state.client).openBrowser(url);
		},
		goDownloadPage: function () {
			let _that = this;
			let url = _that.$store.state.app_url.windows;
			if (navigator.userAgent.indexOf("Mac") != -1) {
				//It is Mac
				url = _that.$store.state.app_url.mac_dmg;
			}
			_that.$common.bridge(_that.$store.state.client).openBrowser(url);
		},
		goDownloadUrl: function () {
			let _that = this;
			let url = "https://www.iepose.com/jdxb/pc/download";
			_that.$common.bridge(_that.$store.state.client).openBrowser(url);
		},
		downloadMacMstscHelpClick: function () {
			let _that = this;
			let url =
				"https://docs.microsoft.com/zh-cn/windows-server/remote/remote-desktop-services/clients/remote-desktop-mac";
			_that.$common.bridge(_that.$store.state.client).openBrowser(url);
		},
		downloadMacMstscClick: function () {
			let _that = this;
			let url =
				"https://cdn.ionewu.com/upgrade/jdxb/v2/MicrosoftRemoteDesktopBeta.app.zip";
			_that.$common.bridge(_that.$store.state.client).openBrowser(url);
		},
		showWakeupTips: function () {
			let _that = this;
			_that.$emit("showWakeupTips");
		},
		ignoreRemoteWakeupTips: function () {
			let _that = this;
			_that.$common.localStorage.setItem("ignoreRemoteWakeupTips", true);
			_that.wakeupClick();
		},
		wakeupClick: function () {
			let _that = this;
			_that.$emit("wakeupClick");
		},
		goPay: function () {
			let _that = this;
			_that.$emit("goPay");
		},
		onRemoteWakeupNextClick: function () {
			let _that = this;
			if (_that.remoteWakeupStep < 3) {
				_that.remoteWakeupStep++;
			} else {
				_that.wakeupClick();
			}
		},
		onRemoteWakeupPrevClick: function () {
			let _that = this;
			if (_that.remoteWakeupStep > 1) {
				_that.remoteWakeupStep--;
			}
		},
		closeClick: function () {
			//通知父组件
			let _that = this;
			_that.$emit("closeMessageAlertClick");
		},
		refreshInstallNasClick: function () {
			//通知父组件
			let _that = this;
			_that.$emit("refreshInstallNasClick");
		},
		installQhNasClick: function () {
			let _that = this;
			_that.installNasQhFlag = true;
			_that.installNasFlag = false;
		},
		installHkNasClick: function () {
			let _that = this;
			_that.installNasHkFlag = true;
		},
		disappearClick: function () {
			let _that = this;
			_that.disappear_icon_flag = !_that.disappear_icon_flag;
		},
		removeServiceClick: function () {
			//通知父组件
			let _that = this;
			_that.$emit("removeServiceSureClick");

			if (_that.disappear_icon_flag) {
				_that.$common.localStorage.setItem(
					"jdxb-remove-service-message-alert",
					"0"
				); //0删除服务时不再显示该弹框
			}
		},
		doUnbindClick: function () {
			//通知父组件
			let _that = this;
			_that.showUnbindCheck();
		},
	},
};
</script>

<style scoped lang="less">
.wakeup-success-wrap {
	text-align: center;
	.close-btn {
		background-image: url(../assets/mall/exchange_alert_close.png);
		background-size: 100% 100%;
		width: 15px;
		height: 15px;
		position: absolute;
		right: 15px;
		top: 15px;
		cursor: pointer;
	}
	.close-btn:hover {
		opacity: 0.8;
	}
	.wakeup-success-icon {
		width: 58px;
		height: 58px;
		background-image: url(../assets/home/node/remote_open_icon.svg);
		background-size: 100% auto;
		margin: 0 auto;
		margin-top: 30px;
		margin-bottom: 30px;
	}
	.wakeup-success-title {
		font-size: 17px;
		font-weight: bolder;
		margin-top: 30px;
		text-align: center;
		color: #1a1a1a;
	}
	svg {
		margin-top: 20px;
		width: 60px;
		height: 60px;
	}
	.wakeup-success-tips {
		font-size: 12px;
		margin-top: 10px;
		text-align: center;
		color: #999999;
		span {
			color: #1f5de3;
			cursor: pointer;
		}
		span:hover {
			opacity: 0.8;
		}
	}
	.done-btn {
		background-color: #e5e5e5;
		width: 100px;
		height: 41px;
		line-height: 41px;
		border-radius: 102px;
		text-align: center;
		box-shadow: 0px 0px 8px 1px rgba(193, 193, 193, 0.6);
		background-color: #5186f9;
		color: #f4f4f4;
		margin: 20px auto 0 auto;
		cursor: pointer;
	}
	.done-btn:hover {
		opacity: 0.9;
	}
}
.message-tip {
	.install-plugin-tip {
		.close-btn {
			background-image: url(../assets/mall/exchange_alert_close.png);
			background-size: 100% 100%;
			width: 15px;
			height: 15px;
			position: absolute;
			right: 15px;
			top: 15px;
			cursor: pointer;
		}

		.title {
			margin-top: 27px;
			text-align: center;
			color: #191919;
			font-size: 20px;
			font-weight: bold;
		}

		.message-box {
			.message-text1 {
				margin-top: 24px;
				color: #666666;
				font-size: 14px;
				text-align: center;
			}

			.plugs {
				display: flex;
				justify-content: center;
				margin-top: 24px;
				font-size: 12px;
				color: #f4f4f4;
				position: relative;

				.plug2-tip {
					position: absolute;
					top: 0;
					left: 322px;
					width: 148px;
					height: 30px;
					background-repeat: no-repeat;
					background-size: 100% 100%;
					background-image: url("../assets/home/node/plug_hk.png");

					.plug2-tip-text {
						color: #666666;
						font-size: 12px;
						white-space: nowrap;
						transform: scale(0.75);
						font-weight: bold;
						margin-top: 3px;
						margin-left: -8px;

						span {
							color: #f0af2d;
						}
					}
				}

				.plug1-icon,
				.plug2-icon {
					width: 102px;
					height: 102px;
					line-height: 102px;
					border-radius: 102px;
					background-repeat: no-repeat;
					background-size: 100% 100%;
					text-align: center;
					cursor: pointer;
				}
				.plug1-icon {
					margin-right: 44px;
					background-image: url("../assets/home/node/plug1.png");
				}
				.plug2-icon {
					position: relative;
					background-image: url("../assets/home/node/plug2.png");
				}

				.plug1-icon:hover,
				.plug2-icon:hover {
					opacity: 0.9;
				}
			}
		}

		.qh-plug-box {
			padding-top: 1px;
			position: relative;
			margin-top: 16px;
			margin-left: 43px;
			width: 367px;
			height: 152px;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			background-image: url("../assets/home/node/plug_qh.png");

			.qh-plug-text {
				position: absolute;
				top: 5px;
				left: 140px;
				color: #666666;
				font-size: 12px;
			}
			.qh-plugs-wrap {
				display: flex;
				align-items: center;
				margin-left: 26px;

				.qh-plug-text1 {
					margin-top: 38px;
					width: 45px;
					font-size: 12px;
					height: 30px;
					line-height: 30px;
					color: #f4f4f4;
					font-weight: bold;
					padding-right: 10px;
					background-repeat: no-repeat;
					background-size: 11px 10px;
					background-image: url("../assets/home/node/plug_arrow.png");
					background-position: right center;
				}

				.qh-plugs {
					margin-top: 50px;
					margin-left: 32px;
					div {
						display: inline-block;
						margin-right: 10px;
						margin-bottom: 10px;
						width: 109px;
						height: 31px;
						line-height: 31px;
						text-align: center;
						background-color: #1f5de3;
						border-radius: 3px;
						font-size: 14px;
						color: #f4f4f4;
					}
				}
			}
		}

		.install-nas-refresh-wrap {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 10px;
			.install-plugin-refresh {
				margin-left: -5px;
				font-size: 12px;
				color: #999999;
			}
			img {
				margin-left: 4px;
				width: 14px;
				height: 14px;
			}
		}
	}

	.install-client-tip {
		.close-btn {
			background-image: url(../assets/mall/exchange_alert_close.png);
			background-size: 100% 100%;
			width: 15px;
			height: 15px;
			position: absolute;
			right: 15px;
			top: 15px;
			cursor: pointer;
		}
		img {
			margin-top: 65px;
			margin-left: 54px;
			width: 153px;
			height: 98px;
		}
		.install-client-text {
			display: inline-block;
			width: 235px;
			vertical-align: top;
			margin-top: 65px;
			margin-left: 30px;

			.install-client-text1 {
				color: #191919;
				font-size: 14px;
				font-weight: bold;
			}
			.install-client-icons {
				margin-top: 5px;
				.install-client-icon {
					width: 54px;
					height: 20px;
					display: inline-block;
					background-size: 100% 100%;
					margin-right: 8px;
				}
				.install-client-icon-01 {
					background-image: url(../assets/home/node/windows_icon_02.svg);
				}
				.install-client-icon-02 {
					background-image: url(../assets/home/node/windows_icon_01.svg);
				}
			}
			.install-client-text2 {
				margin-top: 10px;
				color: #666666;
				font-size: 12px;
			}
			.install-client-text3 {
				margin-top: 5px;
				color: #1f5de3;
				font-size: 12px;
			}
			.install-client-text3:hover {
				text-decoration: underline;
				cursor: pointer;
			}
		}
		.line {
			margin-top: 20px;
			height: 1px;
			background-color: #e5e5e5;
		}
		.install-client-btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}
		.install-client-btn {
			margin-top: 12px;
			margin-left: 265px;
			width: 167px;
			line-height: 41px;
			height: 41px;
			box-sizing: border-box;
			border-radius: 102px;
			background-color: #5186f9;

			.install-client-btn-text {
				display: inline-block;
				vertical-align: top;
				white-space: nowrap;
				color: #f4f4f4;
				font-size: 12px;
				margin-left: 15px;
			}
			.install-client-icon {
				display: inline-block;
				margin-top: 3.5px;
				margin-left: 5px;
				width: 34px;
				height: 34px;
				border-radius: 34px;
				background-color: #1f5de3;
				background-image: url("../assets/home/node/client_arrow1.png");
				background-size: 17px 17px;
				background-position: center;
				background-repeat: no-repeat;
			}
		}

		.install-mac-mstsc-btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}
		.install-mac-mstsc-btn {
			margin-top: 12px;
			margin-left: 225px;
			width: 250px;
			line-height: 41px;
			height: 41px;
			box-sizing: border-box;
			border-radius: 102px;
			background-color: #5186f9;

			.install-client-btn-text {
				display: inline-block;
				vertical-align: top;
				white-space: nowrap;
				color: #f4f4f4;
				font-size: 12px;
				margin-left: 15px;
			}
			.install-client-icon {
				display: inline-block;
				margin-top: 3.5px;
				margin-left: 5px;
				width: 34px;
				height: 34px;
				border-radius: 34px;
				background-color: #1f5de3;
				background-image: url("../assets/home/node/client_arrow1.png");
				background-size: 17px 17px;
				background-position: center;
				background-repeat: no-repeat;
			}
		}
	}

	.help-tip {
		position: relative;
		padding-top: 1px;

		.skip {
			position: absolute;
			right: 20px;
			top: 10px;
			border-bottom: 1px solid #999999;
			.skip-text {
				font-size: 12px;
				color: #999999;
				transform: scale(0.85);
				cursor: pointer;
			}
		}

		.help-title {
			margin-top: 20px;
			font-size: 15px;
			color: #191919;
			text-align: center;
			font-weight: bold;
		}
		.help-text-wrap {
			height: 161px;
			box-sizing: border-box;
			img {
				margin-top: 10px;
				margin-left: 43px;
				margin-bottom: 15px;
				width: 147px;
				height: 130px;
			}
			.help-tip-text {
				display: inline-block;
				margin-top: 25px;
				margin-left: 26px;
				width: 225px;
				vertical-align: top;

				.help-tip-text1 {
					color: #191919;
					font-size: 14px;
				}
				.help-tip-text2 {
					margin-top: 14px;
					color: #666666;
					font-size: 12px;
				}
			}
		}
		.help-text-wrap1 {
			height: 161px;
			box-sizing: border-box;
			padding-left: 20px;
			padding-right: 20px;

			.help-text1 {
				color: #191919;
				font-size: 14px;
			}
			.help-text2 {
				margin-top: 8px;
				margin-bottom: 5px;
				color: #666666;
				font-size: 12px;
			}
			.help-text3 {
				display: flex;
				align-items: center;
				padding-top: 10px;
				padding-bottom: 10px;
				background-color: #ededed;
				.help-text3-box {
					div {
						font-size: 12px;
						transform: scale(0.75);
					}
				}
				.bios-setting-line {
					width: 1px;
					height: 50px;
					border-left: 1px dashed #cccccc;
					box-sizing: border-box;
				}
			}
			.help-text4 {
				margin-top: 5px;
				font-size: 12px;
				color: #666666;
				margin-left: -37px;
				transform: scale(0.85);
				span {
					color: #5186f9;
				}
			}
		}
		.help-text-wrap2 {
			height: 161px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: center;

			.start-wrap {
				margin-left: -5px;
				width: 165px;
				height: 120px;

				.start-text1 {
					margin-top: 10px;
					color: #191919;
					font-size: 14px;
				}
				.start-text2 {
					margin-top: 7px;
					color: #666666;
					font-size: 12px;
				}
			}
			img {
				width: 189px;
				height: 120px;
			}
		}

		.help-line {
			margin-bottom: 10px;
			height: 1px;
			background-color: #e5e5e5;
		}
		.help-steps-icon {
			margin-top: 0;
			margin-left: 20px;
			width: 27px;
			height: 7px;
		}

		.last-step,
		.next-step {
			display: inline-block;
			background-color: #e5e5e5;
			width: 100px;
			height: 41px;
			line-height: 41px;
			border-radius: 102px;
			text-align: center;
		}
		.last-step:hover,
		.next-step:hover {
			cursor: pointer;
			opacity: 0.9;
		}
		.last-step {
			margin-left: 194px;
			margin-right: 20px;
		}
		.last-step,
		.next-step {
			color: #999999;
			box-shadow: 0px 0px 4px 0px rgba(193, 193, 193, 0.3);
		}
		.last-step.active,
		.next-step.active {
			box-shadow: 0px 0px 8px 1px rgba(193, 193, 193, 0.6);
			background-color: #5186f9;
			color: #f4f4f4;
		}
	}

	.add-device-wrap {
		position: relative;
		padding-top: 14px;
		width: 100%;
		height: 100%;
		text-align: center;

		img {
			position: absolute;
			top: 15px;
			right: 24px;
			width: 16px;
			height: 16px;
		}
		.add-device-title {
			font-size: 15px;
			color: #191919;
			font-weight: bold;
			text-align: center;
		}
		.add-device-line {
			margin-top: 14px;
			height: 1px;
			width: 100%;
			background-color: #e5e5e5;
		}
		.bind-code-text {
			margin-left: 40px;
			text-align: left;
			margin-top: 20px;
			color: #999999;
			font-size: 12px;
		}
		input {
			margin-top: 10px;
			width: 287px;
			height: 41px;
			border-radius: 58px;
			border: 1px solid #f0af2d;
			box-shadow: 0px 0px 8px 0px rgba(240, 175, 45, 0.3);
			box-sizing: border-box;
			padding-left: 10px;
			color: #666666;
			font-size: 14px;
		}
		input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
			-webkit-appearance: none;
		}
		input[type="number"] {
			-moz-appearance: textfield;
		}
		.add-device-btn {
			display: inline-block;
			margin-top: 35px;
			border-radius: 102px;
			width: 187px;
			height: 41px;
			line-height: 41px;
			background-color: #f8c257;
			background-image: linear-gradient(to right, #f8c257, #f0ae2c);
			color: #ffffff;
			font-size: 14px;
		}
	}
	.remove-device-wrap {
		position: relative;
		padding-top: 14px;
		width: 100%;
		height: 100%;
		text-align: center;
		box-shadow: 0px 0px 12px 4px #aaaaaa;

		.remove-device-close {
			position: absolute;
			top: 15px;
			right: 24px;
			width: 16px;
			height: 16px;
			cursor: pointer;
		}
		.remove-device-title {
			font-size: 15px;
			color: #191919;
			font-weight: bold;
			text-align: center;
		}
		.remove-device-line {
			margin-top: 14px;
			height: 1px;
			width: 100%;
			background-color: #e5e5e5;
		}
		.remove-device-tip {
			display: flex;
			align-items: center;
			margin: 0 auto;
			margin-top: 14px;
			width: 328px;
			height: 68px;
			background-color: rgba(240, 175, 45, 0.1);

			img {
				margin-top: 9px;
				margin-left: 14px;
				width: 60px;
				height: 60px;
				display: inline-block;
				vertical-align: top;
			}

			div {
				text-align: left;
				color: #666666;
				font-size: 14px;
				width: 250px;
				line-height: 20px;
				display: inline-block;
				vertical-align: top;
				margin-top: 5px;
			}
		}

		.bind-device-tip {
			display: block;
			text-align: left;
			height: 85px;
			img {
				margin-top: 16px;
				margin-left: 14px;
				margin-right: 10px;
				width: 36px;
				height: 36px;
			}
			div {
				margin-top: 16px;
				font-size: 14px;
			}
		}

		.remove-device-btn {
			margin: 0 auto;
			margin-top: 30px;
			border-radius: 102px;
			width: 187px;
			height: 41px;
			line-height: 41px;
			background-color: #f8c257;
			background-image: linear-gradient(to right, #f8c257, #f0ae2c);
			color: #ffffff;
			font-size: 14px;
			cursor: pointer;
		}
		.remove-device-btn:hover {
			opacity: 0.9;
		}
		.go-pay-btn {
			margin: 0 auto;
			margin-top: 30px;
			border-radius: 102px;
			width: 187px;
			height: 41px;
			line-height: 41px;
			background-color: #f2d7b3;
			background-image: linear-gradient(to right, #f2d7b3, #e9c29b);
			color: #5f4509;
			font-size: 14px;
			font-weight: bolder;
		}
		.go-pay-btn:hover {
			cursor: pointer;
			opacity: 0.8;
		}
		.disappear-wrap {
			margin-top: 7px;
			text-align: center;

			.disappear-icon {
				width: 10px;
				height: 10px;
				background-repeat: no-repeat;
				background-image: url("../assets/login/uncheck.png");
				background-size: 100% 100%;
				display: inline-block;
				vertical-align: top;
				margin-top: 3px;
			}
			.disappear-icon-checked {
				background-image: url("../assets/login/checked.png");
			}
			.disappear-text {
				margin-top: 0px;
				margin-left: 2px;
				color: #999999;
				font-size: 12px;
				display: inline-block;
				vertical-align: top;
			}
			.disappear-text:hover {
				cursor: pointer;
			}
		}
	}
	.device-unbind-check-wrap {
		position: absolute;
		left: 50%;
		top: 50%;
		width: 300px;
		height: 180px;
		margin-left: -150px;
		margin-top: -90px;
		border-radius: 5px;
		background-color: #ffffff;
		box-shadow: 0 0 4px #cccccc;
		text-align: center;
		.check-title {
			font-size: 18px;
			font-weight: bolder;
			margin-top: 25px;
		}
		.check-tips {
			font-size: 14px;
			margin-top: 20px;
		}
		.check-name {
			font-size: 14px;
			margin-top: 4px;
		}
		.check-btns {
			margin-top: 15px;
			.check-btn {
				display: inline-block;
				vertical-align: top;
				width: 100px;
				height: 30px;
				line-height: 30px;
				border-radius: 15px;
				font-size: 13px;
			}
			.check-btn:hover {
				opacity: 0.9;
				cursor: pointer;
			}
			.check-sure-btn {
				background-color: #cdcdcd;
				margin-right: 10px;
				color: #ffffff;
			}
			.check-cancel-btn {
				background-color: #f8c257;
				background-image: linear-gradient(to right, #f8c257, #f0ae2c);
				color: #ffffff;
			}
		}
	}
	.device-unbind-wrap {
		position: relative;
		padding-top: 14px;
		width: 100%;
		height: 100%;
		text-align: center;

		.device-unbind-close {
			position: absolute;
			top: 15px;
			right: 24px;
			width: 16px;
			height: 16px;
			cursor: pointer;
		}
		.device-unbind-title {
			font-size: 15px;
			color: #191919;
			font-weight: bold;
			text-align: center;
		}

		.device-unbind-tip {
			align-items: center;
			margin: 0 auto;
			margin-top: 14px;
			width: 328px;
			height: 84px;
			background-color: rgba(240, 138, 44, 0.1);

			img {
				align-self: flex-start;
				margin-top: 20px;
				margin-right: 10px;
				margin-left: 14px;
				width: 36px;
				height: 36px;
				display: inline-block;
				vertical-align: top;
			}

			div {
				text-align: left;
				color: #666666;
				font-size: 12px;
				width: 260px;
				line-height: 20px;
				display: inline-block;
				vertical-align: top;
				margin-top: 20px;
			}
		}
		.device-unbind-btn-group {
			margin-top: 35px;

			.device-unbind-btn1,
			.device-unbind-btn2 {
				display: inline-block;
				color: #ffffff;
				font-size: 14px;
				text-align: center;
				line-height: 41px;
			}
			.device-unbind-btn1:hover,
			.device-unbind-btn2:hover {
				cursor: pointer;
				opacity: 0.9;
			}
			.device-unbind-btn1 {
				width: 121px;
				height: 41px;
				border-radius: 102px;
				background-color: #cdcdcd;
				background-image: linear-gradient(to right, #cdcdcd, #c0c0bf);
			}
			.device-unbind-btn2 {
				margin-left: 27px;
				width: 143px;
				height: 41px;
				border-radius: 102px;
				background-color: #f8c257;
				background-image: linear-gradient(to right, #f8c257, #f0ae2c);
			}
		}
	}

	.download-win-v2 {
		position: relative;
		padding-top: 1px;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		text-align: center;
		background-image: linear-gradient(180deg, #f4f7ff 0%, #ffffff 20%);
		.download-close {
			position: absolute;
			right: 0;
			top: 0;
			background-image: url("../assets/remote/control6.svg");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			width: 46px;
			height: 46px;
			cursor: pointer;
		}
		.tip {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			line-height: 36px;
			height: 36px;
			text-align: center;
			padding-left: 22px;
			padding-right: 22px;
			background: rgba(0, 0, 0, 0.7);
			border-radius: 8px;
			font-weight: 600;
			font-size: 14px;
			color: #ffffff;
		}
		.download-title {
			margin-top: 32px;
			font-weight: 600;
			font-size: 20px;
			line-height: 28px;
			color: #1a1a1a;
		}
		.download-title2 {
			position: relative;
			margin-top: 8px;
			display: inline-block;
			vertical-align: top;
			font-size: 14px;
			line-height: 20px;
			color: #133976;
		}
		.download-title2::before {
			position: absolute;
			top: 1px;
			left: -20px;
			width: 16px;
			height: 16px;
			content: "";
			background-image: url("../assets/remote/control1.svg");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
		.download-title2::after {
			position: absolute;
			top: 1px;
			right: -20px;
			width: 16px;
			height: 16px;
			content: "";
			background-image: url("../assets/remote/control2.svg");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
		.download-item-wrap {
			margin-top: 26px;
			.item-left {
				display: inline-block;
				margin-right: 16px;
				vertical-align: top;
				width: 120px;
				height: 86px;
				background-image: url("../assets/remote/control3.svg");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
			.item-right {
				display: inline-block;
				vertical-align: top;
				.right1,
				.right2 {
					width: 106px;
					height: 36px;
					line-height: 36px;
					background-color: #e6fafe;
					border: 1px solid #d7e5e8;
					box-shadow: 0px 2px 4px rgba(191, 191, 191, 0.2);
					border-radius: 24px;
					color: #666666;
					.right-icon {
						display: inline-block;
						margin-top: 7px;
						margin-right: 4px;
						vertical-align: top;
						background-image: url("../assets/remote/control4.svg");
						background-repeat: no-repeat;
						background-size: 100% 100%;
						width: 20px;
						height: 20px;
					}
				}
				.right1:hover,
				.right2:hover {
					cursor: pointer;
					opacity: 0.8;
				}
				.right2 {
					margin-top: 8px;
					background-color: #e6f1fe;
					border: 1px solid #d8d7e8;
					.right-icon {
						background-image: url("../assets/remote/control5.svg");
					}
				}
			}
		}
		.download-item2 {
			position: relative;
			margin-top: 24px;
			display: inline-block;
			vertical-align: top;
			font-size: 14px;
			line-height: 24px;
			color: #666666;
		}
		.download-item2::before {
			position: absolute;
			left: -106px;
			top: 11px;
			content: "";
			width: 95px;
			height: 1px;
			background-color: #dee0e4;
		}
		.download-item2::after {
			position: absolute;
			left: 108px;
			top: 11px;
			content: "";
			width: 95px;
			height: 1px;
			background-color: #dee0e4;
		}
		.copy-class {
			margin: 0 auto;
			margin-top: 4px;
			width: 312px;
			height: 33px;
			background-color: #f6f8fb;
			border-radius: 4px;
			font-size: 12px;
			line-height: 33px;
			color: #666666;
			cursor: pointer;
		}
	}
}
</style>
